/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from "react"
import { AppBar, Toolbar } from "@mui/material"
import { createTheme } from "@mui/material/styles"
import UIService from "../../../services/UIService"
import { PageConfig, CwComponentConfig } from "../../../models/pageConfig"
import ComponentsUtils from "../../../utils/components"

const theme = createTheme()
const CwAppBar = (
    props: PageConfig<CwComponentConfig.AppBar>
): React.JSX.Element => {
    const { config } = props
    // création de toute les variables à partir des config
    const {
        background,
        color,
        leftComponents,
        rightComponents,
        centerComponents,
    } = config
    const className = config.className ? config.className : ""

    const [state, setState] = useState<{
        left: Array<React.JSX.Element>
        right: Array<React.JSX.Element>
        center: Array<React.JSX.Element>
    }>({
        left: [],
        right: [],
        center: [],
    })

    useEffect(() => {
        let leftElements: React.JSX.Element[] = []
        let rightElements: React.JSX.Element[] = []
        let centerElements: React.JSX.Element[] = []
        if (leftComponents?.length)
            leftElements =
                ComponentsUtils.initChildFieldsComponent(leftComponents)
        if (rightComponents?.length)
            rightElements =
                ComponentsUtils.initChildFieldsComponent(rightComponents)
        if (centerComponents?.length)
            centerElements =
                ComponentsUtils.initChildFieldsComponent(centerComponents)
        setState({
            left: leftElements,
            right: rightElements,
            center: centerElements,
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    /**
     * getColor attribue la couleur adéquate, soit à partir du théme ou à partir
     * d'une couleur
     */
    const appBarColor = color ? UIService.getColorByName(color) : "black"
    const appBarBackground = background
        ? UIService.getColorByName(background)
        : "white"

    return (
        <AppBar
            position="fixed"
            sx={{
                color: appBarColor,
                background: appBarBackground,
                transition: theme.transitions.create(["width", "margin"], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                zIndex: 1300,
            }}
        >
            <Toolbar>
                <div className="flexBox fullWidth">
                    <div className="flexBox">{state.left}</div>
                    <div className={`${className} flexBox`}>{state.center}</div>
                    <div className="flexBox positionRight">{state.right}</div>
                </div>
            </Toolbar>
        </AppBar>
    )
}

export default CwAppBar
